<template>
  <b-dropdown :value="value" @input="onOptionSelected" aria-role="list">
    <!-- Button-->
    <button class="button" type="button" slot="trigger">
      <b-icon icon="chart-bar"></b-icon>
      <span>
        {{ value ? 'Compare workers' : 'Single chart' }}
        <b-icon icon="menu-down"></b-icon>
      </span>
    </button>

    <!-- Options to choose-->
    <b-dropdown-item :value="false" aria-role="listitem">
      Single chart
    </b-dropdown-item>
    <b-dropdown-item :value="true" aria-role="listitem">
      Compare workers
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
  export default {
    props: {
      value: { type: Boolean, required: true }
    },
    methods: {
      onOptionSelected(value) {
        this.$emit('input', value)
      }
    }
  }
</script>